import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="lnl-container py-24 text-center" data-testid="not-found">
            <div className="font-heading text-6xl font-bold text-lnl-green-deep">404</div>
            <div className="mt-2 text-lnl-charcoal font-heading text-xl">This page could not be found.</div>
            <div className="mt-6 flex flex-wrap gap-3 justify-center">
                <Link to="/" className="lnl-btn-primary">Return home</Link>
                <Link to="/admissions" className="lnl-btn-secondary">Go to Admissions</Link>
            </div>
        </div>
    );
}
